const colorPallete = { 
  black90: "#191919",
  white: "#ffffff",
  black: "#000000",
  grey50: "#fafafb",
  grey100: "#f6f6f7", 
  grey200: "#eaebeb",
  grey300: "#e0e0e1",
  grey400: "#d0d0d0",
  grey500: "#afafaf",  
  grey600: "#676768",
  grey600DisabledText: "#777779", 
  grey700: "#313333",
  grey800: "#1b1c1c",
  grey900: "#151515",
  primaryRed500: "#cc1f20",
  primaryMaroon500: "#e61717",
  secondaryLightblue500: "#d9e8f2",
  secondaryNavy500: "#0d3954",
  semanticRed50: "#faebeb",
  semanticRed500: "#c83b33",
  semanticOrange50: "#fcf1eb",
  semanticOrange500: "#e27637",
  semanticOrange800: "#7c411e",
  semanticYellow50: "#fef9ec",
  semanticYellow500: "#f2be43",
  semanticYellow800: "#856925",
  semanticGreen50: "#eef8ee",
  semanticGreen500: "#007738",
  semanticGreen800: "#31642f",
  saveSemanticGreen800: "#063404",
  semanticBlue50: "#ecf3fa",
  semanticBlue500: "#4083ca",
  semanticBlue800: "#23486f",
  breadcrumbColor: "#071f2e",
  greyDisabled600: "#777779",
  semanticBlueBg50: "#E5F6FF",
  semanticBlueBgText800: "#0C3157",
  saveSemanticGreen50: "#CCFBE7",
  saveSemanticGreen500: "#007738",
  monoBlack: "#0C0C0C",
  semanticError: "#AE0C19",
  semanticColorOrange500: "#E76F19",
  statusTagBlue: "#D7E7F1",
}

const themeFontWeights = {
  regular: 400, 
  semiBold: 600
}

const themeFonts = {
  fontImportUrl: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap",
  fontFamilyRoboto: "'Roboto', sans-serif",
  fontFamilyMonteserrat: "'Montserrat', serif",
}

const elevation = {
  dp04: "0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
  dp16: "0px 4px 16px 0px rgba(0, 0, 0, 0.20)",
  dp08: "0px 8px 16px 0px rgba(0, 0, 0, 0.15)",
  dp04With25: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
}

const buttonFonts = {
  buttonLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    fontSize: "16px",
    lineHeight: "20.8px",
  },
  buttonSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    fontSize: "14px",
    lineHeight: "18.2px",
  }
}

const printFonts = {
  bodyRegularExtraSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "13.5px",
    fontSize: "9px"
  },
  bodySemiboldExtraSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "13.5px",
    fontSize: "9px"
  },
  bodyRegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "15px",
    fontSize: "10px"
  },
  bodySemiboldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "15px",
    fontSize: "10px"
  },
  bodyRegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "16.5px",
    fontSize: "11px"
  },
  bodySemiboldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "16.5px",
    fontSize: "11px"
  },
  headingLevel1: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "18px",
    fontSize: "12px"
  }
}

const bodyFonts = {
   body1RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "24px",
    fontSize: "16px"
   },
   body1SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "24px",
    fontSize: "16px"
   },
   body2RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "21px",
    fontSize: "14px"
   },
   body2SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "21px",
    fontSize: "14px"
   },
   body1RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "24px",
    fontSize: "16px"
   },
   body1SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "24px",
    fontSize: "16px"
   },
   body2RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "21px",
    fontSize: "14px"
   },
   body2SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "21px",
    fontSize: "14px"
   },
}

const labelFonts = {
  label1Regular: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "18px",
    fontSize: "12px"
  },
  label1SemiBold: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "18px",
    fontSize: "12px"
  },
  label2Regular: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "15px",
    fontSize: "10px"
  },
  label2SemiBold: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "15px",
    fontSize: "10px"
  },
  label3Regular: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "15px",
    fontSize: "10px"
  },
  label3SemiBold: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "15px",
    fontSize: "10px"
  },
  label4Regular: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular, 
    lineHeight: "15px",
    fontSize: "10px"
  },
  label4SemiBold: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "15px",
    fontSize: "10px"
  }
}

const headlineFonts = {
  headline1RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "41.6px",
    fontSize: "32px"
  },
  headline1SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "41.6px",
    fontSize: "32px"
  },
  headline2RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "36.4px",
    fontSize: "28px"
  },
  headline2SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "36.4px",
    fontSize: "28px"
  },
  headline3RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "31.2px",
    fontSize: "24px"
  },
  headline3SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "31.2px",
    fontSize: "24px"
  },
  headline4RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline4SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline5RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline5SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline6RegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "24px",
    fontSize: "16px"
  },
  headline6SemiBoldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "24px",
    fontSize: "16px"
  },
  headline1RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "36.4px",
    fontSize: "28px"
  },
  headline1SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "36.4px",
    fontSize: "28px"
  },
  headline2RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "31.2px",
    fontSize: "24px"
  },
  headline2SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "31.2px",
    fontSize: "24px"
  },
  headline3RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline3SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline4RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline4SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "30px",
    fontSize: "20px"
  },
  headline5RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "24px",
    fontSize: "16px"
  },
  headline5SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "24px",
    fontSize: "16px"
  },
  headline6RegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "21px",
    fontSize: "14px"
  },
  headline6SemiBoldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "21px",
    fontSize: "14px"
  },
}

const specialHeadings = {
  specialTestimonialLg: {
    fontFamily: themeFonts.fontFamilyMonteserrat,
    fontSize: "30px",
    lineHeight: "39px"
  },
  specialTestimonialSm: {
    fontFamily: themeFonts.fontFamilyMonteserrat,
    fontSize: "24px",
    lineHeight: "31.2px"
  }
}

const displayHeading = {
  displayRegularLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "49.4px",
    fontSize: "38px"
  },
  displayRegularSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.regular,
    lineHeight: "44.2px",
    fontSize: "34px"
  },
  displaySemiboldLg: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "49.4px",
    fontSize: "38px"
  },
  displaySemiboldSm: {
    fontFamily: themeFonts.fontFamilyRoboto,
    fontWeight: themeFontWeights.semiBold,
    lineHeight: "44.2px",
    fontSize: "34px"
  }
}

const themeBreakPointSize = {
  mobileSmall: "390px", 
  mobileLarge: "767px",
  tabletSmall: "768px",
  tabletLarge: "1024px",
  laptopSmall: "1280px",
  laptopLarge: "1440px"
}
const themeBreakPointValues = {
  mobileSmall: 390, 
  mobileLarge: 767,
  tabletSmall: 768,
  tabletLarge: 1024,
  laptopSmall: 1280,
  laptopLarge: 1440
}
export default colorPallete;
export { themeFonts, themeFontWeights, buttonFonts, printFonts, bodyFonts, labelFonts, headlineFonts, specialHeadings, elevation, themeBreakPointSize, displayHeading, themeBreakPointValues };